var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Star-Solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.4-Drivers---Distance",
    transform: "translate(-1004.000000, -900.000000)",
    fill: "#0375BA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(914.000000, 773.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(90.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Star-Solid",
    points: "5 0 6.17241379 3.82758621 10 3.82758621 6.89655172 6.17241379 8.10344828 10 5 7.62068966 1.89655172 10 3.10344828 6.17241379 0 3.82758621 3.82758621 3.82758621"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarSolid);
export default __webpack_public_path__ + "static/media/Icon-Star-Solid.1a44137c27702d173dfa5c4c93b495fd.svg";
export { ForwardRef as ReactComponent };